<template>
     <search-group    :btnOffset="18" :btnSpan="6" :multipleLines="true" @search="findData" @clear="clearValue" :span="24" :inline="true">
        <Row class="mb16" :gutter="16">
            <Col span="4">
              <Select v-model="searchData.cityCode" placeholder="城市" @on-change="changeCity">
                <Option v-for="item in openCityEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.projectFid" placeholder="项目" @on-change="changeProject">
                <Option  v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.houseBuildingFid" placeholder="楼栋">
                <Option  v-for="item in buildingList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.houseTypeFid" placeholder="房型名称">
                 <Option value="" >请选择</Option>
                <Option  v-for="item in houseTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.stockStatus" placeholder="房间状态">
                <Option value="" >请选择</Option>
                <Option  v-for="item in houseOutStatusEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.stockVacancyDay" placeholder="空置天数">
                <Option value="" >请选择</Option>
                <Option v-for="item in stockVacancyDayEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>

          </Row>
          <Row class="mb16" :gutter="16">
            <Col span="4">
              <Select v-model="searchData.stockRentDate" placeholder="可出租时间">
                <Option value="" >请选择</Option>
                <Option  v-for="item in houseRentDateEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.stockType" placeholder="出租方式">
                <Option value="" >请选择</Option>
                <Option  v-for="item in stockTypeEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.houseDecorationStyle" placeholder="装修风格">
                <Option value="" >请选择</Option>
                <Option  v-for="item in houseDecorationStyleEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.stockIsOrder"  placeholder="预定状态">
                <Option value="" >请选择</Option>
                <Option  v-for="item in stockOrderEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Input type="text"
                v-model="searchData.stockNumber"
                placeholder="请输入想查询的房间号"
                @keyup.enter.native="findData">
              </Input>
            </Col>

        </Row>
         <Row :gutter="16">
             <Col span="4">
             <Select v-model="searchData.limitLabel"  placeholder="房源性别限制">
                 <Option value="" >请选择</Option>
                 <Option  v-for="item in genderLabelsEnum" :value="item.value" :key="item.value">{{item.text}}</Option>
             </Select>
             </Col>
         </Row>
    </search-group>
</template>

<script type="text/ecmascript-6">

import SearchGroup from 'components/SearchGroup/index';
import { getSelectedData } from "api/outHouse"
import { buildInfo,getHouseType } from "api/house"

export default {
    props:{
      selectedData:{
        type:Object,
        default:null
      }
    },
    created(){
      // this.findData()
    },
    watch:{
      selectedData: {
        deep: true,
        handler(val){
          this.openCityEnums = val.openCityEnums
          this.stockVacancyDayEnums = val.stockVacancyDayEnums
          this.houseOutStatusEnums = val.houseOutStatusEnums
          this.stockRentTypeEnums = val.stockRentTypeEnums // 整组，合租
          this.houseRentDateEnums = val.houseRentDateEnums
          this.houseDecorationStyleEnums = val.houseDecorationStyleEnums
          this.stockTypeEnums = val.stockTypeEnums
          this.genderLabelsEnum = val.genderLabelsEnum
          this.stockOrderEnums=val.stockOrderEnums
          if(this.openCityEnums.length > 0) {
            this.searchData.cityCode = this.openCityEnums[0].value
            this.getProjectList(this.searchData.cityCode)
          }
          this.searchData.stockStatus = 0 //默认查询待租中, 这里0是写死的,对应后台待租中枚举值
        }
      }
    },
    components: {
      SearchGroup
    },
    data () {
        return {
          stockOrderEnums:[],
          openCityEnums:[],
          stockVacancyDayEnums:[],
          houseOutStatusEnums:[],
          stockRentTypeEnums:[],
          houseRentDateEnums:[],
          houseDecorationStyleEnums:[],
          genderLabelsEnum:[],
          stockTypeEnums:[],
          projectList:[],
          buildingList:[],
          houseTypeList:[],
          searchData:{
            cityCode:'',
            houseBuildingFid: '',
            houseDecorationStyle: '',
            houseFloorNumber: '',
            houseTypeFid: '',
            projectFid: '',
            stockNumber: '',
            stockRentDate: '',
            stockRentType: 0,
            stockStatus: '',
            stockType: '',
            stockVacancyDay: '',
            stockIsOrder:'',
            limitLabel:''
          }
        }
    },
    methods: {
      getProjectList(cityCode) {
        buildInfo(cityCode).then( res => {
          this.projectList = res.data
          if(this.projectList.length > 0){
            this.searchData.projectFid = this.projectList[0].value
            this.getBuidingInfo(this.searchData.projectFid)
          }
        })
      },
      getBuidingInfo(projectFid){
        for (let [index, item] of this.projectList.entries()) {
          if (projectFid === item.value) {
            this.buildingList = this.projectList[index].children;
          }
        }
        if(this.buildingList.length > 0) {
          this.searchData.houseBuildingFid = this.buildingList[0].value
        }
      },
      changeCity(val) {
        if(val==='') {
          this.projectList = []
        } else {
          this.getProjectList(val)
        }
      },
      changeProject(value) {
          if(value === '') {
            this.buildingList = []
            this.houseTypeList = []
          }else{
            this.getBuidingInfo(value)
            this.$emit('postBuildingList',this.buildingList)
            getHouseType(value).then(res => {
              this.houseTypeList = res.data.houseTypeList
            })
        }
      },
      findData() {
          this.$emit('findData', this.searchData);
      },
      clearValue() {
        for(let key in  this.searchData){
          if(key==='cityCode' || key==='houseBuildingFid' || key==='projectFid' || key==='stockRentType') continue
          this.searchData[key]=''
        }
      }
    }
}
</script>
<style scoped>
.error-tip {
    position: absolute;
    color: #F56356;
  }
</style>

